export const STATION_IDS = [
  "skierg",
  "sled-push",
  "sled-pull",
  "burpee-broad-jumps",
  "row",
  "farmers-carry",
  "sandbag-lunges",
  "wall-balls",
] as const;

export type StationId = (typeof STATION_IDS)[number];

export interface StationDefinition {
  id: StationId;
  name: string;
  /** Short label for small screens (watch faces); at most 8 characters. */
  shortName: string;
  amount: number;
  unit: "m" | "reps";
}

/** The eight stations in race order. */
export const STATIONS: readonly StationDefinition[] = [
  { id: "skierg", name: "SkiErg", shortName: "SkiErg", amount: 1000, unit: "m" },
  { id: "sled-push", name: "Sled Push", shortName: "Push", amount: 50, unit: "m" },
  { id: "sled-pull", name: "Sled Pull", shortName: "Pull", amount: 50, unit: "m" },
  { id: "burpee-broad-jumps", name: "Burpee Broad Jumps", shortName: "BBJ", amount: 80, unit: "m" },
  { id: "row", name: "Row", shortName: "Row", amount: 1000, unit: "m" },
  { id: "farmers-carry", name: "Farmers Carry", shortName: "Farmers", amount: 200, unit: "m" },
  { id: "sandbag-lunges", name: "Sandbag Lunges", shortName: "Lunges", amount: 100, unit: "m" },
  { id: "wall-balls", name: "Wall Balls", shortName: "WallBall", amount: 100, unit: "reps" },
];

export const RACE_LEGS = STATIONS.length;
export const RUN_DISTANCE_KM = 1;
/** In a relay each athlete covers this many consecutive run + station legs. */
export const RELAY_LEGS_PER_ATHLETE = 2;
